import React, { useEffect, useState } from 'react';
import { useLocation } from 'umi';
import { emailJumpToUnsubscribe } from '../../services/substribe';

import '@/pages/dashboard/assets/scss/page/Subscribe/unsubscribe.scss';
import dataBrainBlueLogo from '@/pages/dashboard/assets/images/subscribe/data-brain-blue-logo.svg';
import Loading from '../../components/Loadings';

const UnSubscribeResult = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [haveUnsubscribed, setHaveUnsuscribed] = useState(false);
  const message={
    dashboard: 'You have been successfully removed from this subscriber list and will not receive any further reports for this specific game.',
    intelligence: 'You have been successfully removed from this subscriber list.',
  };
  const [tipMsg, setTipMsg] = useState(message.dashboard);

  useEffect(() => {
    const { search } = location;
    // 此处不能直接用location.query取content，query中的内容会把url中的加号改为空格
    // const content = search?.split('?content=')?.[1] || ''
    // 存在某些退订url里还带了除content以外的信息, 并且已被编译处理，需兼容处理一下
    const content = search?.split('?')?.[1].split('&')?.find((info:string)=>info.includes('content='))?.split('content=')?.[1]  || '';
    setLoading(true);
    setHaveUnsuscribed(false);
    emailJumpToUnsubscribe({ content: encodeURIComponent(decodeURIComponent(content)) }).then((res) => {
      if(res.push_type === 4){
        setTipMsg(message.intelligence);
      }
      setHaveUnsuscribed(true);
    }).catch(() => {
      setHaveUnsuscribed(false);
    }).finally(() => {
      setLoading(false);
    });
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (<div className='dbd-un-subscribe-box'>
    <div className='dbd-un-subscribe'>
      <div className='dbd-un-subscribe-img-box'><img src={dataBrainBlueLogo} /></div>
      <div className='dbd-un-subscribe-title'>{haveUnsubscribed ? 'Unsubscribe Successful' : 'Unsubscription Failed'}</div>
      <div className='dbd-un-subscribe-content'>
        {
          haveUnsubscribed ? <>{tipMsg}</> :
            <>Please contact <span className='dbd-un-subscribe-content-email'>ivyyfchen@tencent.com</span> for further assistance.</>
        }
      </div>
    </div>
  </div>);
};

export default UnSubscribeResult;